import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/Layout'

Vue.use(Router)

export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/login'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/home'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/cmm',
    component: Layout,
    redirect: '/cmm/cmInfo',
    name: 'cmm',
    alwaysShow: true,
    meta: {title: '耗材管理', icon: 'product'},
    children: [
      {
        path: 'cmInfo',
        name: 'cmInfo',
        component: () => import('@/views/cmm/index'),
        meta: {title: '耗材信息', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/som',
    component: Layout,
    redirect: '/som/soInfo',
    name: 'som',
    alwaysShow: true,
    meta: {title: '科室管理', icon: 'product'},
    children: [
      {
        path: 'soInfo',
        name: 'soInfo',
        component: () => import('@/views/som/index'),
        meta: {title: '科室信息', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/container',
    component: Layout,
    redirect: '/container/containerInfo',
    name: 'container',
    alwaysShow: true,
    meta: {title: '货柜管理', icon: 'product'},
    children: [
      {
        path: 'containerInfo',
        name: 'containerInfo',
        component: () => import('@/views/container/index'),
        meta: {title: '货柜信息', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/label',
    component: Layout,
    redirect: '/label',
    name: 'label',
    alwaysShow: true,
    meta: {title: '标签管理', icon: 'product'},
    children: [
      {
        path: 'labelInfo',
        name: 'labelInfo',
        component: () => import('@/views/label/index'),
        meta: {title: '标签信息', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/store',
    component: Layout,
    redirect: '/store',
    name: 'store',
    alwaysShow: true,
    meta: {title: '仓库管理', icon: 'product'},
    children: [
      {
        path: 'storeInfo',
        name: 'storeInfo',
        component: () => import('@/views/store/index'),
        meta: {title: '库存信息', icon: 'product-list'}
      },
      {
        path: 'deliverInfo',
        name: 'deliverInfo',
        component: () => import('@/views/store/deliver'),
        meta: {title: '配送信息', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/apply',
    component: Layout,
    redirect: '/apply',
    name: 'apply',
    alwaysShow: true,
    meta: {title: '申领管理', icon: 'product'},
    children: [
      {
        path: 'manualApply',
        name: 'manualApply',
        component: () => import('@/views/apply/manualApply'),
        meta: {title: '手动申领', icon: 'product-list'}
      },
      {
        path: 'applyInfo',
        name: 'applyInfo',
        component: () => import('@/views/apply/index'),
        meta: {title: '申领单信息', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/station',
    component: Layout,
    redirect: '/station',
    name: 'station',
    alwaysShow: true,
    meta: {title: '基站管理', icon: 'product'},
    children: [
      {
        path: 'stationInfo',
        name: 'stationInfo',
        component: () => import('@/views/station/index'),
        meta: {title: '基站信息', icon: 'product-list'}
      },
      {
        path: 'stationConfig',
        name: 'stationConfig',
        component: () => import('@/views/station/config/stationConfig'),
        meta: {title: '基站配置', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/user',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/ums/user/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  mode: 'history', // 后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/router.js